import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {

    return (
        <div className='footer-panel'>
            <div className='footer-links'>
                <Link to='/cms/terms-and-conditions'>Terms & Conditions</Link>
                <Link to='/cms/privacy-policy'>Privacy Policy</Link>
            </div>
            <p>© Copyright {moment().format("YYYY")} Inside Rodeo</p>
        </div>
    )
}